import type { WikiTemplate } from '../../../shared/types';

export const getWikiTemplateByType = (
  templates: WikiTemplate[],
  templateType?: string | null
): WikiTemplate | null => {
  const normalizedType = (templateType || '').trim().toLowerCase();
  if (!normalizedType) return null;

  return (
    templates.find((template) => template.key.toLowerCase() === normalizedType) || null
  );
};

export const normalizeWikiTemplateData = (
  template: WikiTemplate | null,
  templateData?: Record<string, string> | null
): Record<string, string> => {
  if (!template) return {};

  const source = templateData || {};
  const normalized: Record<string, string> = {};

  for (const field of template.fields) {
    normalized[field.key] = (source[field.key] || '').trim();
  }

  return normalized;
};

export const validateWikiTemplateData = (
  template: WikiTemplate | null,
  templateData: Record<string, string>
): Record<string, string> => {
  if (!template) return {};

  const errors: Record<string, string> = {};
  for (const field of template.fields) {
    if (!field.required) continue;
    const value = (templateData[field.key] || '').trim();
    if (!value) {
      errors[field.key] = `${field.label} is required.`;
    }
  }
  return errors;
};
